import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import axios from "axios";
import { format } from "date-fns";
import { differenceInDays, parseISO } from "date-fns";
import { Tooltip } from "@mui/material";
import { CheckCircle, Warning, Error } from "@mui/icons-material";

const DataTableSwitchCase = ({ endpoint }) => {

    console.log("endpoint DataTableSwitchCase", endpoint)

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const pageSize = 20;

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
        const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits for day
        return `${year}-${month}-${day}`;
    };

    const todayDate = getTodayDate();

    useEffect(() => {
        fetchTableData();
    }, [endpoint]);

    const fetchTableData = async () => {
        try {
            let apiUrl = `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`

            console.log("apiUrl DataTableSwitchCase", apiUrl)

            const response = await axios.get(
                // `https://cubixweberp.com:213/api/HRDashboard/SUNRISE/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
                apiUrl
            );
            const data = response.data;
            console.log("data>>>++", response.data);
            if (endpoint === "CRM_CUSTOMER_AQUI") {
                console.log("CRM_SALESMAN_PERFORM data:", data);
            }
            setTableData(data);
        } catch (error) {
            console.error("Error while fetching table data", error);
        }
    };


    const getColumn = () => {

        if (endpoint == "Current_Stock_Position") {
            return [
                { field: "GROUP", headerName: "Group", flex: 0.3 },
                { field: "CurrentQty", headerName: "Current Qty", flex: 1 },
                { field: "StockValue", headerName: "Stock Value", flex: 2 },
            ]
        } else if (endpoint == "Stock_By_Location") {
            return [
                { field: "StoreLocationCode", headerName: "Store Location Code", flex: 0.3 },
                { field: "StoreName", headerName: "Store Name", flex: 1 },
                { field: "BranchCode", headerName: "Branch Code", flex: 2 },
                { field: "BranchName", headerName: "Branch Name", flex: 0.3 },
                { field: "ItemCount", headerName: "ItemCount", flex: 1 },
                { field: "TotalQty", headerName: "TotalQty", flex: 2 },
                { field: "StockValue", headerName: "Stock Value", flex: 2 },
            ]
        } else if (endpoint == "Fast_Moving_Items_90Days_Top50") {
            return [
                { field: "ItemCode", headerName: "Item Code", flex: 0.3 },
                { field: "ItemDescription", headerName: "Item Description", flex: 1 },
                { field: "group", headerName: "Group", flex: 2 },
                { field: "TotalSoldQty", headerName: "Total Sold Qty", flex: 0.3 },
                { field: "TransactionCount", headerName: "Transaction Count", flex: 1 },
            ]
        } else if (endpoint == "Non_Moving_Items_90Days") {
            return [
                { field: "ItemCode", headerName: "Item Code", flex: 0.3 },
                { field: "ItemDescription", headerName: "Item Description", flex: 1 },
                { field: "CurrentQty", headerName: "CurrentQty", flex: 2 },
                { field: "AvgCost", headerName: "AvgCost", flex: 0.3 },
                { field: "StockValue", headerName: "StockValue", flex: 1 },
            ]
        } else if (endpoint == "Inventory_Valuation_Report") {
            return [
                { field: "ItemGroup", headerName: "Item Code", flex: 0.3 },
                { field: "TotalQty", headerName: "Item Description", flex: 1 },
                { field: "TotalValue", headerName: "CurrentQty", flex: 2 },
            ]
        } else if (endpoint == "Stock_Aging_Report") {
            return [
                { field: ["0-30 Days"], headerName: "0-30 Days", flex: 0.3 },
                { field: ["31-60 Days"], headerName: "31-60 Days", flex: 1 },
                { field: ["61-90 Days"], headerName: "61-90 Days", flex: 2 },
                { field: ["91-180 Days"], headerName: "91-180 Days", flex: 2 },
                { field: ["180+ Days"], headerName: "180+ Days", flex: 2 },
                { field: "TotalValue", headerName: "Total Value", flex: 2 },
            ]
        } else if (endpoint == "Todays_Sales_Branch") {
            return [
                { field: "Branch_ID", headerName: "Branch ID", flex: 0.3 },
                { field: "Branch_Name", headerName: "Branch_Name", flex: 1 },
                { field: "CashSale", headerName: "CashSale", flex: 2 },
                { field: "CreditSale", headerName: "CreditSale", flex: 2 },
                { field: "CashReturn", headerName: "CashReturn", flex: 2 },
                { field: "CreditReturn", headerName: "CreditReturn", flex: 2 },
                { field: "NetAmount", headerName: "NetAmount", flex: 2 },
            ]
        } else if (endpoint == "Todays_Sales_Branch_Salesperson") {
            return [
                { field: "Branch_ID", headerName: "Branch ID", flex: 0.3 },
                { field: "Branch_Name", headerName: "Branch_Name", flex: 1 },
                { field: "Salesman", headerName: "Salesman", flex: 2 },
                { field: "CashSale", headerName: "CashSale", flex: 2 },
                { field: "CreditSale", headerName: "CreditSale", flex: 2 },
                { field: "CashReturn", headerName: "CashReturn", flex: 2 },
                { field: "CreditReturn", headerName: "CreditReturn", flex: 2 },
                { field: "NetAmount", headerName: "NetAmount", flex: 2 },
            ]
        }



    }

    const columns = getColumn()


    const getRow = () => {

        if (endpoint == "Current_Stock_Position") {
            return tableData.map((item, index) => ({
                id: item.GROUP,
                GROUP: item.GROUP,
                CurrentQty: item.CurrentQty,
                StockValue: item.StockValue,
            }))
        } else if (endpoint == "Stock_By_Location") {
            return tableData.map((item, index) => ({
                id: item.StoreLocationCode,
                StoreLocationCode: item.StoreLocationCode,
                StoreName: item.StoreName,
                BranchCode: item.BranchCode,
                BranchName: item.BranchName,
                ItemCount: item.ItemCount,
                TotalQty: item.TotalQty,
                StockValue: item.StockValue

            }))
        } else if (endpoint == "Fast_Moving_Items_90Days_Top50") {
            return tableData.map((item, index) => ({
                id: item.ItemCode,
                ItemCode: item.ItemCode,
                ItemDescription: item.ItemDescription,
                group: item.group,
                TotalSoldQty: item.TotalSoldQty,
                TransactionCount: item.TransactionCount

            }))
        } else if (endpoint == "Non_Moving_Items_90Days") {
            return tableData.map((item, index) => ({
                id: item.ItemCode,
                ItemCode: item.ItemCode,
                ItemDescription: item.ItemDescription,
                CurrentQty: item.CurrentQty,
                AvgCost: item.AvgCost,
                StockValue: item.StockValue

            }))
        } else if (endpoint == "Inventory_Valuation_Report") {
            return tableData.map((item, index) => ({
                id: item.ItemGroup,
                TotalQty: item.TotalQty,
                TotalValue: item.TotalValue,

            }))
        } else if (endpoint == "Stock_Aging_Report") {
            return tableData.map((item, index) => ({
                id: item.ItemGroup,
                ["0-30 Days"]: item["0-30 Days"],
                ["31-60 Days"]: item["31-60 Days"],
                ["61-90 Days"]: item["61-90 Days"],
                ["91-180 Days"]: item["91-180 Days"],
                ["180+ Days"]: item["180+ Days"],
                TotalValue: item.TotalValue

            }))
        } else if (endpoint == "Todays_Sales_Branch") {
            return tableData.map((item, index) => ({
                id: item.Branch_ID,
                Branch_ID: item.Branch_ID,
                Branch_Name: item.Branch_Name,
                CashSale: item.CashSale,
                CreditSale: item.CreditSale,
                CashReturn: item.CashReturn,
                CreditReturn: item.CreditReturn,
                NetAmount: item.NetAmount

            }))
        } else if (endpoint == "Todays_Sales_Branch_Salesperson") {
            return tableData.map((item, index) => ({
                id: item.Salesman,
                Branch_ID: item.Branch_ID,
                Branch_Name: item.Branch_Name,
                Salesman: item.Salesman,
                CashSale: item.CashSale,
                CreditSale: item.CreditSale,
                CashReturn: item.CashReturn,
                CreditReturn: item.CreditReturn,
                NetAmount: item.NetAmount,

            }))
        }


    }
    const rows = getRow()


    return (
        <div className="w-full overflow-x-auto">

            { (rows && columns) ?
                <Paper sx={{ minWidth: 600, height: 400 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        checkboxSelection
                        pagination
                        paginationMode="server"
                        page={page}
                        pageSizeOptions={[pageSize]}
                        rowCount={rows?.length}
                        onPageChange={(newPage) => setPage(newPage)}
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeader": {
                                fontFamily: "'Figtree', sans-serif",
                                background: "#27446A",
                                color: "#F8F8F8",
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
                            {
                                color: "#FFFFFF", // hide the "Select All" label space
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                                color: "#FFFFFF", // unselected checkbox color
                            },
                            "& .MuiDataGrid-columnHeaderCheckbox .Mui-checked": {
                                color: "#FFFFFF", // selected checkbox color
                            },
                            "& .MuiDataGrid-cell": {
                                padding: "1px 2px",
                                fontFamily: "'Figtree', sans-serif",
                            },
                        }}
                    />
                </Paper>
                :
                <div>No data found</div>
            }
        </div>
    );
};

export default DataTableSwitchCase;